"use strict";
module.exports = {
    'v1.validooArticle.resolveGtin': 'validoo',
    'v1.validooArticle.createFlaivyArticle': 'validoo',
    'v1.validooArticle.upsert': 'validoo',
    'v1.validooArticle.upsertWhenEmpty': 'validoo',
    'v1.validooArticle.updateWhenEmpty': 'validoo',
    'v1.validooArticle.update': 'validoo',
    'v1.validooSubscription.createGTINSubscription': 'validoo',
    'v1.validooSubscription.createGLNSubscription': 'validoo',
    'v1.validooSubscription.upsert': 'validoo',
    'v1.validooSubscription.upsertWhenEmpty': 'validoo',
    'v1.validooSubscription.updateWhenEmpty': 'validoo',
    'v1.validooSubscription.update': 'validoo',
    'v1.validooCredential.upsert': 'validoo',
    'v1.validooCredential.upsertWhenEmpty': 'validoo',
    'v1.validooCredential.updateWhenEmpty': 'validoo',
    'v1.validooCredential.update': 'validoo',
    'v1.validooEventsource.cleanUpOldEvents': 'validoo',
    'v1.validooEventsource.undoEvent': 'validoo',
    'v1.validooEventsource.reEmit': 'validoo',
};
